import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';



class Cab extends Component {
    handleClick = () => {
      return <Redirect to="/"/>
    }
  render() {
    return (
      <nav>
        <ul>
            <li className="cabecera" onClick={this.handleClick} style={{cursor:'pointer'}}></li>
        </ul>
        <ul >
            <li></li> 
        </ul>
     </nav>
    );
  }
}

export default Cab;


// WEBPACK FOOTER //
// ./src/components/cabecera.js